import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="hidden border-t border-slate-200 bg-white/70 dark:border-slate-800 dark:bg-slate-900/70 xl:block">
      <div className="flex items-center justify-between px-4 py-3 text-xs text-slate-500 dark:text-slate-400 sm:px-6 lg:px-8">
        <span>&copy; {new Date().getFullYear()} Hednesford Data Hub</span>
        <span>Built for coaches, scouts, managers</span>
      </div>
    </footer>
  );
};

export default Footer;
